module.exports = __webpack_public_path__ + "static/img/5areaB_12.2abc2ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/5areaB_12.png
// module id = 1193
// module chunks = 1